import * as React from 'react';

import { FAQsContainer } from '@/components/Elements';

export const FaqsPage = () => {
  return <FAQsContainer />;
};
